import React, { Component } from 'react';
import { axiosAPI as axios } from 'utils';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cs from 'classnames';

import { imagesURL } from 'config';
import { getMasterOrganizationById } from 'actions/commonActions';
import {
  changeLocale,
  showError,
  showInfo,
  showConfirmPromise,
} from 'actions/statusActions';
import LoginHelp from './login/LoginHelp';
import LoginForm from './login/LoginForm';
import {
  redirect,
  getTranslateFunc,
  formatHtmlForPlay,
  parseQueryString,
} from 'utils';
import { Spinner } from 'components/common';
import API from 'api';
import MobileWrapperFamilyLogin from './MobileWrapperFamilyLogin/MobileWrapperFamilyLogin';
import isMobileAppRuntime from 'utils/isMobileAppRuntime';
import classes from './Login.module.scss';

const langToFont = {
  din: 'din',
};

export class Login extends Component {
  static MAX_IMAGES = 10; // 

  constructor(props) {
    super(props);

    const { match } = props;
    const { learningCenterUrl } = match.params;    

    // 
    const sessionKey = `imageProgress_${learningCenterUrl}`;
    const savedProgress = JSON.parse(sessionStorage.getItem(sessionKey) || '{}');
    const lastShownNumber = savedProgress.lastShownNumber || 0;
    const sequentialMode = savedProgress.sequentialMode !== false; // true
    const successfulImages = savedProgress.successfulImages || [];

    //
    let imgNumber = sequentialMode ? lastShownNumber + 1 : 1;
    if (!sequentialMode && successfulImages.length > 0) {
      imgNumber = successfulImages[Math.floor(Math.random() * successfulImages.length)];
    }
    if (imgNumber > Login.MAX_IMAGES) {
      imgNumber = successfulImages.length > 0
        ? successfulImages[Math.floor(Math.random() * successfulImages.length)]
        : 1;
    }

    const query = parseQueryString(this.props.location.search);

    this.state = {
      learningCenter: null,
      family: query.family && decodeURI(query.family),
      lastFamilyId: query.family && decodeURI(query.family),
      availableLocales: [],
      familyMembers: [],
      learningCenterUrl,
      imgNumber,
      processing: false,
      product: {},
      instructionsData: {},
      bgImg: this.getBackgroundImage(learningCenterUrl, imgNumber),
      useDefaultImage: false,
      attemptCount: 0,
      triedImages: [imgNumber],
      successfulImages,
      sequentialMode,
      lastShownNumber,
      maxAttempts: Login.MAX_IMAGES,
      initialized: false,
      mobileWrapperFamilyLogin:
        isMobileAppRuntime() && !!localStorage.getItem('flcMobileFamilyAccountToken'),
    };
  }

  handleChangeTeamType = (nextFamilyTeam = true) => {
    const newLocation = this.props.location;
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const isOnePerson = params.get('onePerson') === 'true' || this.state.product?.onePerson;
    const rememberedFamilyId = params.get('family') || this.state.family || this.state.lastFamilyId || '';

    console.log('[Login][handleChangeTeamType][before]', {
      nextFamilyTeam,
      rememberedFamilyId,
      isOnePerson,
      search: url.search,
    });

    if (params.get('onePerson') === 'true') {
      this.setState({ product: { onePerson: true } });
    }

    if (!nextFamilyTeam && !isOnePerson) {
      params.delete('family');
      this.setState((prevState) => ({
        familyMembers: [],
        family: '',
        lastFamilyId: prevState.lastFamilyId || rememberedFamilyId || '',
      }));
    } else if (rememberedFamilyId) {
      params.set('family', rememberedFamilyId);
      this.fetchFamilyMembers(rememberedFamilyId);
      this.setState({
        family: rememberedFamilyId,
        lastFamilyId: rememberedFamilyId,
      });
    }

    url.search = params.toString();
    window.history.replaceState({}, document.title, url.toString());
    newLocation.search = url.search;

    console.log('[Login][handleChangeTeamType][after]', {
      nextFamilyTeam,
      search: url.search,
      family: params.get('family') || '',
    });

    return newLocation;
  }

  // 
  getBackgroundImage = (learningCenterUrl, imgNumber, isDefault = false) => {
    const cacheBuster = `?cache=${Date.now()}`;
    const urlSegment = learningCenterUrl || 'default';
    const defaultImgNumber = Math.floor(Math.random() * 4) + 1;
    if (isDefault && learningCenterUrl) {      
      const url = `${imagesURL}/Images/Login/background${defaultImgNumber}-${urlSegment}.jpg${cacheBuster}`;
      console.log(`Generated default image URL with urlSegment: ${url}`);
      return url;
    }  
    else if (isDefault && !learningCenterUrl) {
      const url = /*this.state.product.onePerson 
      ? `${imagesURL}/Images/Login/background1-onePerson.jpg${cacheBuster}`
      : */`${imagesURL}/Images/Login/background${defaultImgNumber}.jpg${cacheBuster}`;
      console.log(`Generated default image URL: ${url}`);
      return url;
    }   
    const url = `${imagesURL}/Images/Login/background${imgNumber}-${urlSegment}.jpg${cacheBuster}`;
    console.log(`Generated specific image URL: ${url}`);
    return url;
  };

  // sessionStorage
  saveProgress = () => {
    const { learningCenterUrl, sequentialMode, lastShownNumber, successfulImages } = this.state;
    const sessionKey = `imageProgress_${learningCenterUrl}`;
    sessionStorage.setItem(
      sessionKey,
      JSON.stringify({
        sequentialMode,
        lastShownNumber,
        successfulImages,
      })
    );
  };

  // 
  preloadImage = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = url;
      img.onload = () => resolve(true);
      img.onerror = () => reject(false);
    });
  };

  // 
  handleImageError = () => {
    const { learningCenterUrl, attemptCount, triedImages, successfulImages, sequentialMode, lastShownNumber, maxAttempts } = this.state;
    console.log(`Image load failed: ${this.state.bgImg}, attempt ${attemptCount + 1}, Tried: [${triedImages}], Successful: [${successfulImages}], LearningCenter: ${learningCenterUrl}`);

    if (attemptCount < maxAttempts - 1) {
      let nextImgNumber;
      if (sequentialMode) {
        nextImgNumber = lastShownNumber + 1;
        if (nextImgNumber > Login.MAX_IMAGES) {
          this.setState({ sequentialMode: false }, this.saveProgress);
        }
      }

      if (!sequentialMode || nextImgNumber > Login.MAX_IMAGES) {
        if (successfulImages.length > 0) {
          nextImgNumber = successfulImages[Math.floor(Math.random() * successfulImages.length)];
        } else {
          const defaultBgImg = this.getBackgroundImage('', null, true);
          console.log(`No successful images, falling back to default: ${defaultBgImg}`);
          this.setState({
            bgImg: defaultBgImg,
            useDefaultImage: true,
            attemptCount: 0,
            triedImages: [],
            sequentialMode: false,
          }, this.saveProgress);
          return;
        }
      }

      if (triedImages.includes(nextImgNumber)) {
        const defaultBgImg = this.getBackgroundImage('', null, true);
        console.log(`All images tried, falling back to default: ${defaultBgImg}`);
        this.setState({
          bgImg: defaultBgImg,
          useDefaultImage: true,
          attemptCount: 0,
          triedImages: [],
          sequentialMode: false,
        }, this.saveProgress);
      } else {
        const nextBgImg = this.getBackgroundImage(learningCenterUrl, nextImgNumber);
        console.log(`Trying next image: ${nextBgImg}`);
        this.preloadImage(nextBgImg)
          .then(() => {
            this.setState({
              imgNumber: nextImgNumber,
              bgImg: nextBgImg,
              attemptCount: attemptCount + 1,
              triedImages: [...triedImages, nextImgNumber],
              successfulImages: [...successfulImages, nextImgNumber],
              lastShownNumber: sequentialMode ? nextImgNumber : lastShownNumber,
            }, this.saveProgress);
          })
          .catch(() => {
            this.setState({
              attemptCount: attemptCount + 1,
              triedImages: [...triedImages, nextImgNumber],
            }, this.handleImageError);
          });
      }
    } else {
      const defaultBgImg = this.getBackgroundImage('', null, true);
      console.log(`Falling back to default image: ${defaultBgImg}`);
      this.setState({
        bgImg: defaultBgImg,
        useDefaultImage: true,
        attemptCount: 0,
        triedImages: [],
        sequentialMode: false,
      }, this.saveProgress);
    }
  };

  // 
  handleImageLoad = () => {
    const { imgNumber, successfulImages, sequentialMode } = this.state;
    if (!successfulImages.includes(imgNumber)) {
      console.log(`Image loaded successfully: ${this.state.bgImg}, Number: ${imgNumber}`);
      this.setState({
        successfulImages: [...successfulImages, imgNumber],
        lastShownNumber: sequentialMode ? imgNumber : this.state.lastShownNumber,
      }, this.saveProgress);
    }
  };

  // 
  componentDidMount() {
    if (this.state.mobileWrapperFamilyLogin) return;

    const { bgImg, learningCenterUrl, imgNumber } = this.state;
    console.log(`Preloading initial image: ${bgImg} for ${learningCenterUrl}`);

    // 
    this.continueComponentDidMount();

    // 
    this.preloadImage(bgImg)
      .then(() => {
        console.log(`Initial image loaded: ${bgImg}`);
        this.setState({
          successfulImages: [...this.state.successfulImages, imgNumber],
          lastShownNumber: imgNumber,
        }, this.saveProgress);
      })
      .catch(() => {
        console.log(`Initial image failed: ${bgImg}`);
        this.handleImageError();
      });

  }

 async continueComponentDidMount() {
    const {
      auth,
      common,
      changeLocale,
      getMasterOrganizationById,
      history,
      location,
      showError,
    } = this.props;

    const query = parseQueryString(location.search);
    const { learningCenterUrl, family } = this.state;

    console.log(`Initializing component for ${learningCenterUrl}`);

    if (auth && auth.isAuthenticated) {
      return history.push(redirect(auth));
    }

    const { locales } = common;
    const initialValues = {};

    if (query.autoLogin) initialValues.autoLogin = query.autoLogin === '1';
    if (query.username) initialValues.username = decodeURI(query.username);
    if (query.password) initialValues.password = decodeURI(query.password);
    if (query.username2) initialValues.username2 = decodeURI(query.username2);
    if (query.password2) initialValues.password2 = decodeURI(query.password2);
    if (query.username3) initialValues.username3 = decodeURI(query.username3);
    if (query.password3) initialValues.password3 = decodeURI(query.password3);

    // 
    console.log('Login continueComponentDidMount: initialValues=', initialValues);

    if (query.instructionsData) {
      const instructionsData = JSON.parse(decodeURIComponent(query.instructionsData));
      this.fetchOnePersonByParams({name:instructionsData.productName});
      this.setState({ instructionsData });
      console.log('Login instructionsData: ',instructionsData);
    }

    if (family) {
      this.fetchFamilyMembers(family);
      this.fetchOnePersonStatus(family);
    }

    if (!this.state.learningCenterUrl) {
      this.setState({ initialized: true, initialValues });
      return changeLocale('en');
    }

    const learningCenter = _.find(common.learningCenters, {
      url: this.state.learningCenterUrl,
    });

    if (!learningCenter) {
      return history.push('/');
    }

    const masterOrganization = await getMasterOrganizationById(
      learningCenter.masterOrganizationId
    );

    if (!masterOrganization) {
      return history.push('/login');
    }

    const {
      config: { locales: learningCenterLocales, defaultLocale, offline },
    } = learningCenter;

    if (offline) {
      initialValues.username =
        initialValues.username || localStorage.getItem('flc-username') || '';
      initialValues.username2 =
        initialValues.username2 || localStorage.getItem('flc-username2') || '';
      initialValues.username3 =
        initialValues.username3 || localStorage.getItem('flc-username3') || '';
    }

    const availableLocales = learningCenterLocales
      .map((loc) => _.find(locales, { code: loc }))
      .sort((a, b) => {
        if (a.code === 'en') {
          return -1;
        }
        if (b.code === 'en') {
          return 1;
        }
        return a.displayName < b.displayName ? -1 : 1;
      });

    const localeCodeToSet =
      query.locale || defaultLocale || availableLocales[0] || 'en';
    changeLocale(localeCodeToSet);

    const { expirationDate } = learningCenter;
    if (expirationDate && new Date(expirationDate) < new Date()) {
      const currentTranslate = getTranslateFunc(
        common.strings,
        localeCodeToSet
      );

      showError({
        message: currentTranslate(482, 'Learning Center is expired'),
        cb: () => history.push('/'),
      });
    }

    this.setState(
      {
        masterOrganization,
        learningCenter,
        availableLocales,
        initialized: true,
        initialValues,
      },
      () => {
        const { showInfo, translate } = this.props;
        const { instructionsData } = this.state;

        if (query.showInstructions) {
          const html = translate(
            query.showInstructions,
            'Instructions',
            false,
            true
          );

          showInfo({
            html: true,
            align: 'left',
            message: formatHtmlForPlay({
              data: instructionsData,
              html,
            }),
          });
        }
      }
    );
  }   
      

  async fetchFamilyMembers(familyId) {
    const { showError } = this.props;

    try {
      const response = await axios.get(`/api/auth/get-family-logins-by-family-id/${familyId}`);
      this.setState({ familyMembers: response.data });
    } catch (error) {
      showError({
        message: `Failed to fetch family members: ${error.message}`,
      });
    }
  }

  async fetchOnePersonStatus(familyId) {    
    const { showError } = this.props;

    try {
      const product = await API.onePersonProduct.getOnePersonByFamily(familyId);
      if (product?.onePerson){
        this.setState({ product });
        console.log('Login onePerson: ',product.onePerson);
      }
    } catch (error) {
      showError({
        message: `Failed to fetch family members: ${error.message}`,
      })
    }
  }

  async fetchOnePersonByParams(params) {    
    const { showError } = this.props;

    try {
      const product = await API.onePersonProduct.getOnePersonByParams(params);
      if (product?.onePerson){
        this.setState({ product });
        console.log('Login onePerson: ',product.onePerson);
      }
    } catch (error) {
      showError({
        message: `Failed to fetch family members: ${error.message}`,
      })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { auth, history, location, match } = this.props;
    const query = parseQueryString(location.search);
    //const { product } = this.state;

    if (prevProps.auth !== auth && auth.isAuthenticated) {
      history.push({
        pathname: redirect(auth),
        state: query,
      });
    }

    /*if (prevState.product !== product) {
      const defaultBgImg = this.getBackgroundImage(match.params.learningCenterUrl, 1);
      console.log(`prevState.product image: ${defaultBgImg}`);
      this.setState({
        bgImg: defaultBgImg,
        useDefaultImage: false,
        attemptCount: 0,
        triedImages: [1],
        sequentialMode: true,
      }, this.saveProgress);
      return;
    }*/

    // 
    if (prevProps.match.params.learningCenterUrl !== match.params.learningCenterUrl) {
      const { learningCenterUrl } = match.params;
      const imgNumber = 1;
      const bgImg = this.getBackgroundImage(learningCenterUrl, imgNumber);
      this.setState({
        learningCenterUrl,
        imgNumber,
        bgImg,
        useDefaultImage: false,
        attemptCount: 0,
        triedImages: [imgNumber],
        successfulImages: [],
        sequentialMode: true,
        lastShownNumber: 0,
        initialized: false,
      }, () => {
        sessionStorage.setItem(`imageProgress_${learningCenterUrl}`, JSON.stringify({
          sequentialMode: true,
          lastShownNumber: 0,
          successfulImages: [],
        }));
        this.preloadImage(bgImg)
          .then(() => {
            console.log(`Initial image loaded for new learningCenterUrl: ${bgImg}`);
            this.setState({
              successfulImages: [imgNumber],
              lastShownNumber: imgNumber,
            }, this.saveProgress);
          })
          .catch(() => {
            console.log(`Initial image failed for new learningCenterUrl: ${bgImg}`);
            this.handleImageError();
          });
      });
    }
  }

  onChangeLocale = (e) => {
    const { value: code } = e.target;
    return this.props.changeLocale(code);
  };

  loginErrorHandler = async (data) => {
    if (!data) return;

    const { showError, showInfo, translate, showConfirmPromise } = this.props;
    const { initialValues } = this.state;

    if (initialValues.autoLogin) {
      this.setState({
        initialValues: { ...initialValues, autoLogin: false },
      });
    }

    const { familyAccess, family, familyMember } = data;

    if (!familyAccess) return;

    const {
      resumeSubscription,
      retryTransaction,
      product,
      purchase,
      purchaseInfo,
    } = familyAccess;

    const productName = (product && product.name) || '';

    if (resumeSubscription || retryTransaction) {
      showResumeDialog();
    } else {
      resolvePurchaseStatus();
    }

    async function showResumeDialog() {
      if (!familyMember.isAdmin) {
        return showError({
          html: true,
          align: 'left',
          message: formatHtmlForPlay({
            data: { productName },
            html: translate(
              771,
              `You cannot use ${productName} until your family admin (probably your parent) resumes payments`,
              false,
              true
            ),
          }),
        });
      }

      const isConfirmed = await showConfirmPromise({
        html: true,
        align: 'left',
        message: formatHtmlForPlay({
          data: {
            productName,
            successfulTransactionsNumber: purchaseInfo.successfulTransactionsNumber,
            numberOfBillingCycles: purchaseInfo.numberOfBillingCycles,
          },
          html: translate(
            772,
            `Your account is inactive, although all your record-keeping data has been saved. You have paid ${purchaseInfo.successfulTransactionsNumber} of the ${purchaseInfo.numberOfBillingCycles} installments. Click OK to make a payment and resume using ${productName}.`,
            false,
            true
          ),
        }),
      });

      if (!isConfirmed) return;

      this.setState({ processing: true });

      let result;

      if (resumeSubscription) {
        result = await API.purchase.resumeSubscription(purchase._id, {
          familyId: family._id,
        });
      } else if (retryTransaction) {
        result = await API.purchase.retryPastDueTransaction(purchase._id, {
          familyId: family._id,
        });
      }
      this.setState({ processing: false });

      if (result.success) {
        showInfo({
          message: translate(0, 'Success. You can now try to log in again'),
        });
      } else {
        showError({
          message: translate(
            0,
            `Failed to resume your account. Please re-check your billing card amount and try again`
          ),
        });
      }
    }

    async function resolvePurchaseStatus() {
      const { isPending, isRefunded, isRejected } = purchaseInfo;

      if (isRejected) {
        return showError({
          html: true,
          align: 'left',
          message:
            'Your payment was rejected. Please <a href="mailto:support@familylearningcompany.com">contact us</a> if you have some questions',
        });
      }

      if (isRefunded) {
        return showError({
          html: true,
          align: 'left',
          message:
            'Your payment was refunded. Please <a href="mailto:support@familylearningcompany.com">contact us</a> if you have some questions',
        });
      }

      if (isPending) {
        return showInfo({
          html: true,
          align: 'left',
          message:
            'Your payment is pending. Try to login later. Please <a href="mailto:support@familylearningcompany.com">contact us</a> if you have some questions',
        });
      }
    }
  };

  render() {
    if (this.state.mobileWrapperFamilyLogin) {
      return <MobileWrapperFamilyLogin history={this.props.history} />;
    }

    const { lang, isLandscape } = this.props;
    const {
      learningCenter,
      family,
      familyMembers,
      availableLocales,
      initialValues,
      processing,
      initialized,
      product,
      instructionsData,
      bgImg,
      useDefaultImage,
    } = this.state;

    console.log('Login initialValues: ', initialValues);
    console.log(`Rendering image: ${bgImg}, Default: ${useDefaultImage}`);
    if (!initialized) {
      return null;
    }

    const ellipseProps = isLandscape
      ? {
          cx: '63%',
          cy: '60%',
          rx: '60%',
          ry: '60%',
        }
      : {
          cx: '63%',
          cy: '60%',
          rx: '60%',
          ry: '60%',
        };

    return (
      <>
        {processing && <Spinner />}

        <div
          style={{
            fontFamily: `var(--font-${langToFont[lang?.code] || 'base'})`,
          }}
          className={cs(classes.wrapper, {
            [classes.hidden]: initialValues && initialValues.autoLogin,
          })}
        >
          <div className={classes.inner}>
            <div className={classes.bgImg}>
              <svg width="1200" height="960" viewBox="0 0 1200 960">
                <defs>
                  <filter id="filter">
                    <feGaussianBlur stdDeviation="40" />
                  </filter>
                  <mask id="mask">
                    <ellipse
                      {...ellipseProps}
                      fill="white"
                      filter="url(#filter)"
                    ></ellipse>
                  </mask>
                </defs>
                <image
                  xlinkHref={bgImg}
                  width="1200"
                  height="960"
                  mask="url(#mask)"
                  onError={this.handleImageError}
                  onLoad={this.handleImageLoad}
                ></image>
              </svg>
            </div>
            <div className={classes.top}>
              <div className={classes.logo}>
                <a
                  href="https://familylearningcompany.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    //src={`${imagesURL}/Images/Login/FLCLogo.png`}
                    src="https://s3.us-east-2.amazonaws.com/flink-2.0-fs/Files/LandingPageAssets/Logo/Family_Logo_2024.svg"
                    alt="Familylearningcompany"
                  />
                </a>
              </div>
              {learningCenter && (
                <div className={classes.helpBlock}>
                  <LoginHelp lang={lang} classes={classes} product={product}/>
                </div>
              )}
              {learningCenter && (
                <h1 className={classes.centerName}>{learningCenter.name}</h1>
              )}
            </div>
            <LoginForm
              initialValues={initialValues}
              family={{
                id: family,
                members: familyMembers,
              }}
              learningCenter={learningCenter}
              availableLocales={availableLocales}
              onChangeLocale={this.onChangeLocale}
              onError={this.loginErrorHandler}
              product={product}
              instructionsData={instructionsData}
              handleChangeTeamType={this.handleChangeTeamType}
            />
          </div>
        </div>
      </>
    );
  }
}

Login.propTypes = {
  auth: PropTypes.object.isRequired,
  lang: PropTypes.object,
  common: PropTypes.object.isRequired,
  changeLocale: PropTypes.func.isRequired,
  getMasterOrganizationById: PropTypes.func.isRequired,
  showInfo: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
};

const mapStateToProps = ({ auth, status, common }) => ({
  auth,
  lang: status.lang,
  common,
  translate: status.translate,
  isLandscape: status.aspectRatio > 1,
});

export default compose(
  connect(mapStateToProps, {
    changeLocale,
    getMasterOrganizationById,
    showInfo,
    showConfirmPromise,
    showError,
  })
)(Login);
